RivalIQ.apps.Insights.module('views', function (views, App, Backbone, Marionette, $, _, s, moment) {
    'use strict';

    const BaseDropdown = Marionette.ItemView.mixin({
        attributes: {
            style: 'width: 100%'
        },
        template: '#adNavToolbarSelectorTemplate',
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        }
    });

    const ObjectTypeDropdown = BaseDropdown.extend({
        behaviors: {
            DropdownSelector: {
                prop: 'objectType',
                propDefaultValue: RivalIQ.enums.insightsObjectType.storyDay
            }
        },

        serializeData: function () {
            return {
                label: 'Type',
                selectableItems: [
                    {
                        id: RivalIQ.enums.insightsObjectType.storyDay,
                        name: 'Stories'
                    },
                    {
                        id: RivalIQ.enums.insightsObjectType.story,
                        name: 'Frames'
                    }
                ],
                highlighted: false
            };
        },

        onSelectDropdown: function (data) {
            const me = this;

            // Type should always be a string
            const objectType = data.itemId.toString();
            me.setProps('objectType', objectType);

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.InsightsSetObjectTypeFilter, {
                objectType: objectType
            });
        }
    });

    const PrivateIncompleteDataWarning = views.PrivateIncompleteDataWarning = Marionette.ItemView.mixin({
        template: '#socialPostsIncompleteDataWarningTemplate',

        className: 'incomplete-data-warning',

        ui: {
            warning: '.x-incomplete-data-warning',
            warningTooltipAnchor: '.x-incomplete-data-warning'
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        serializeData: _.noop,

        getTimeZone: function () {
            const me = this;
            return me.getProp('timezone');
        },

        getPostHistorySince: function () {
            const me = this;
            return me.dashboardModel.getCuration().presence.get('post_history_since');
        },

        getMainPeriodStart: function () {
            const me = this;
            return me.getProp('timePeriod').mainPeriodStart;
        },

        getIncompleteHistorySince: function () {
            const me = this;

            const timezone = me.getTimeZone();
            const historySince = moment.utc(me.getPostHistorySince()).tz(timezone);
            const periodStart = moment.utc(me.getMainPeriodStart()).format('YYYY-MM-DD');

            // history in the chosen time zone is before or on the period start day
            return (historySince.isSameOrBefore(periodStart, 'day') ? false : historySince);
        },

        onRender: function () {
            const me = this;

            const getIncompleteHistorySince = me.getIncompleteHistorySince();

            if (getIncompleteHistorySince) {
                const popoverTemplate = _.template($('#privateSocialPostsIncompleteDataWarningMessageTemplate').html());

                const content = popoverTemplate({
                    historySince: getIncompleteHistorySince.format('ll')
                });

                me.ui.warning.show();
                me.ui.warningTooltipAnchor.popover({
                    html: true,
                    content: content,
                    trigger: 'hover',
                    placement: 'auto right',
                    container: 'body'
                });
            } else {
                me.ui.warning.hide();
            }
        }
    });

    const ALL_MEDIA_TYPES = 'ALL';

    function getMediaTypeFilterValue(typeName) {
        return RivalIQ.utils.facebookInsightsMediaType.getFilterValueFromDisplay(typeName);
    }

    const MediaTypeDropdown = BaseDropdown.extend({
        behaviors: {
            DropdownSelector: {
                prop: 'mediaTypeFilter',
                propDefaultValue: '',
                missingContentHtml: function () {
                    const me = this;
                    const propValue = me.view.getProp(me.options.prop);
                    return [s.capitalize(propValue), '(0)'].join(' ');
                }
            }
        },

        itemTemplate: function (item) {
            return $.tagHtml('li', {
                html: $.tagHtml('a', {
                    'data-item-id': item.id,
                    class: ['x-select-item', 'pointer'],
                    html: [
                        $.tagHtml('span', {
                            text: item.name
                        }),
                        $.tagHtml('span', {
                            class: 'text-muted',
                            text: ['(', item.count, ')'].join('')
                        })
                    ].join('&nbsp;')
                })
            });
        },

        serializeData: function () {
            const me = this;

            const data = me.getOption('data');
            let selectableItems = _.map(data, function (datum) {
                return {
                    id: datum[1],
                    name: datum[0],
                    count: datum[2],
                    template: me.itemTemplate
                };
            });

            let label;
            if (me.getProp('objectType') === RivalIQ.enums.insightsObjectType.post) {
                label = 'Post Type';
            } else {
                label = 'Frame Type';
                selectableItems = _.reject(selectableItems, {
                    id: 'carousel'
                });
            }

            const mediaTypeFilter = me.getProp('mediaTypeFilter');
            return {
                label: label,
                selectableItems: selectableItems,
                highlighted: mediaTypeFilter && mediaTypeFilter !== ALL_MEDIA_TYPES
            };
        },

        onSelectDropdown: function (data) {
            const me = this;

            // Type should always be a string
            let mediaTypeFilter = data.itemId.toString();
            if (mediaTypeFilter === ALL_MEDIA_TYPES || _.isEmpty(mediaTypeFilter)) {
                mediaTypeFilter = undefined;
            }
            me.setProps('mediaTypeFilter', mediaTypeFilter);

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.InsightsSetMediaTypeFilter, {
                mediaTypeFilter: mediaTypeFilter,
                channel: me.getProp('channel')
            });
        }
    });

    const TweetTypeMultiSelect = RivalIQ.apps.SocialPosts.views.TweetTypeMultiSelect.extend({
        tweetTypeFilterPropName: 'tweetTypeFilter'
    });

    views.SearchBar = RivalIQ.views.LayoutView.mixin({
        template: '#insightsSearchBarTemplate',

        mixins: {
            props: Marionette.Dashboard.mixins.Props,
            PostTagHelpersMixin: RivalIQ.views.PostTagHelpersMixin
        },

        regions: {
            objectTypeDropdown: '.object-type-dropdown',
            mediaTypeDropdown: '.media-type-dropdown',
            postTagsDropdown: '.post-tag-dropdown',
            tweetTypeDropdown: '.tweet-type-dropdown',
            incompleteDataWarning: '.x-search-incomplete-data'
        },

        ui: {
            searchInputContainer: '.search-input-container',
            searchInput: 'input',
            searchBtn: '.x-search',
            searchResultsSummary: '.search-results-summary',
            searchTips: '.search-tips-link'
        },

        events: {
            'keypress @ui.searchInput': 'onKeyDown',
            'click @ui.searchBtn': 'onSearch',
            'click .x-clear': 'clearSearch'
        },

        dashboardModelEvents: {
            'change': 'reload'
        },

        onKeyDown: function (e) {
            const me = this;

            if (e.which === 13) {
                e.preventDefault();
                me.onSearch();
            }
        },

        loadData: function () {
            const me = this;

            const props = me.getProps();

            let objectType = props.objectType || RivalIQ.enums.insightsObjectType.storyDay;
            const curationId = _.get(me.dashboardModel, ['curation', 'id'], me.dashboardModel.id);

            if (curationId === RivalIQ.enums.curation.INSTAGRAM_INSIGHTS_STORY_DAY) {
                objectType = RivalIQ.enums.insightsObjectType.story;
            }

            let property;
            switch (objectType) {
                case RivalIQ.enums.insightsObjectType.post:
                case RivalIQ.enums.insightsObjectType.story:
                    property = 'count';
                    break;

                case RivalIQ.enums.insightsObjectType.storyDay:
                    property = 'days_with_story';
                    break;
                default:
                    throw new Error(`unknown insight objectType ${objectType}`);
            }

            let metric = App.utils.createInsightsMetric(objectType, _.defaults({
                property: property,
                dimensions: ['timeAnalysisMode', 'channel', 'companyId'],
                objectType: objectType
            }, _.omit(props, 'orderBy', 'sortOrder', 'analysisProperty')));

            metric = new RivalIQ.models.MetricDefinition(metric);

            let metrics = [metric];

            if (objectType === 'post' ||
                (me.dashboardModel.widgetId === RivalIQ.enums.widgetTypes.INSIGHTS_MEDIA && objectType === 'story')) {
                const allTypesDef = metric.build({
                    mediaTypeFilter: undefined
                });
                const byTypeDef = allTypesDef.build({
                    analysisProperty: 'mediaType',
                    dimensions: ['mediaType']
                });
                const typeNameDef = byTypeDef.build({
                    property: 'name'
                });

                metrics = metrics.concat(allTypesDef, byTypeDef, typeNameDef);
                metrics.push(metric.build({
                    property: 'count',
                    dimensions: ['post_tag_ids'],
                    postTagIds: me.getProp('postTagIds'),
                    postTagConjunction: 'OR',
                    postTagExclude: false
                }));
                metrics.push(RivalIQ.postTags.data.PostTags);

                if (me.getProp('source') === RivalIQ.enums.sources.TWITTER_INSIGHTS) {
                    metrics.push(metric.build({
                        analysisProperty: 'tweetType',
                        property: 'count',
                        dimensions: ['tweetType']
                    }));
                }

            }

            const fetches = _.map(metrics, function (m) {
                return m.fetch();
            });

            const view = me.getOption('view');
            const deferred = new $.Deferred();
            $.when.apply($, fetches)
                .then(function (results, allTypes, byType, typeName, postTagIds, postTags, byTweetType) {
                    me.numObjectsMetric = results;

                    me.allTypes = allTypes;
                    me.byType = byType;
                    me.typeName = typeName;
                    me.postTagIds = postTagIds;
                    me.postTags = postTags;
                    me.byTweetType = byTweetType;

                    me.error = null;
                    if (view) {
                        view.toggleView(null, me.numObjectsMetric);
                    }
                })
                .fail(function (xhr) {
                    if (view) {
                        view.toggleView(xhr);
                    }
                    me.error = xhr;
                })
                .always(deferred.resolve);

            return deferred;
        },

        onRender: function () {
            const me = this;

            const objectType = me.getProp('objectType');

            // only show this when in table details view; it's not user editable in the overview.
            if (me.dashboardModel.widgetId === RivalIQ.enums.widgetTypes.INSIGHTS_MEDIA) {

                if (objectType !== 'post' && !me.getProp('storyDay')) {
                    me.objectTypeDropdown.show(new ObjectTypeDropdown({
                        dashboardModel: me.dashboardModel
                    }));
                }
            }
        },

        onRenderLoaded: function () {
            const me = this;

            if (!me.error) {
                const objectType = me.getProp('objectType');
                if (me.byTweetType && me.getProp('source') === RivalIQ.enums.sources.TWITTER_INSIGHTS) {
                    const byTweetTypeCounts = _.reduce(me.byTweetType.getValue({
                        format: false
                    }), function (memo, value) {
                        memo[value[0]] = value[1];
                        return memo;
                    }, {});
                    me.tweetTypeDropdown.show(new TweetTypeMultiSelect({
                        dashboardModel: me.dashboardModel,
                        byTweetTypeCounts: byTweetTypeCounts
                    }));
                }

                if (objectType === 'post') {
                    me.showPostTagsFilter();
                }

                RivalIQ.apps.SocialPosts.utils.setupSearchTipsPopover(me.dashboardModel.id, me.ui.searchTips);

                if (me.numObjectsMetric) {
                    me.showResultsSummary();
                    me.showMediaTypeDropdown();
                }

                me.showIncompleteDataWarning();
            }
        },

        showPostTagsFilter: function () {
            const me = this;
            const SocialPosts = RivalIQ.apps.SocialPosts;

            me.postTagsDropdown.show(new SocialPosts.views.PostTagsFilter({
                dashboardModel: me.dashboardModel,
                postTagIds: me.postTagIds.getValue() || [],
                postTagsById: _.keyBy(me.postTags, 'id')
            }));
        },

        showMediaTypeDropdown: function () {
            const me = this;

            const objectType = me.getProp('objectType');
            if (objectType === 'post' ||
                (me.dashboardModel.widgetId === RivalIQ.enums.widgetTypes.INSIGHTS_MEDIA && objectType === 'story')) {

                const data = [['All Media', '', me.allTypes.getValue()]];
                _.each(_.zip(me.typeName.getValue(), me.byType.getValue()), function (rows) {
                    data.push([rows[0][1], getMediaTypeFilterValue(rows[0][0]), rows[1][1]]);
                });

                me.mediaTypeDropdown.show(new MediaTypeDropdown({
                    dashboardModel: me.dashboardModel,
                    data: data
                }));
            }
        },

        showIncompleteDataWarning: function () {
            const me = this;

            if (me.isDestroyed || me.dashboardModel.getProp('source') !== RivalIQ.enums.sources.TWITTER_INSIGHTS) {
                return;
            }

            me.incompleteDataWarning.show(new PrivateIncompleteDataWarning({
                dashboardModel: me.dashboardModel
            }));
        },

        serializeData: function () {
            const me = this;
            const props = me.dashboardModel.getProps();
            let placeholderValue = 'Search Post Content';

            if (props.channel === 'twitter') {
                placeholderValue = 'Search Tweet Content';
            } else if (props.channel === 'instagram' && (props.objectType === 'story' || props.objectType === 'storyDay')) {
                placeholderValue = 'Search Story Content';
            }
            return _.defaults({}, me.dashboardModel.getProps(), {
                searchTerm: '',
                placeholder: placeholderValue
            });
        },

        _executeSearch: function (searchTerm) {
            const me = this;

            me.setProps({
                searchTerm: searchTerm
            });

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.InsightsSetSearchTerm, {
                channel: me.getProp('channel'),
                searchTerm: searchTerm
            });
        },

        onSearch: function () {
            const me = this;

            const searchTerm = me.ui.searchInput.val().trim();
            me._executeSearch(searchTerm);
        },

        clearSearch: function () {
            const me = this;

            me.setProps({
                searchTerm: undefined
            });
        },

        hideResultsSummary: function () {
            const me = this;

            if (_.isFunction(me.ui.searchResultsSummary.text)) {
                me.ui.searchResultsSummary.text('');
            }
        },

        showResultsSummary: function () {
            const me = this;

            if (me.isDestroyed || me.omitResultsSummary) {
                return;
            }

            const numObjects = me.numObjectsMetric.getValue({
                format: false
            });
            const numObjectsFormatted = me.numObjectsMetric.getValue({
                format: true
            });

            if (numObjects === 0) {
                me.ui.searchResultsSummary.text('No Results Found');
            } else {
                let objectTypeName;
                let objectTypeNamePlural;

                const objectType = me.numObjectsMetric.get('objectType');

                switch (objectType) {
                    case RivalIQ.enums.insightsObjectType.story:
                        objectTypeNamePlural = 'Frames';
                        objectTypeName = 'Frame';
                        break;
                    case RivalIQ.enums.insightsObjectType.storyDay:
                        objectTypeNamePlural = 'Stories';
                        objectTypeName = 'Story';
                        break;
                    case RivalIQ.enums.insightsObjectType.post:
                        objectTypeName = _.upperFirst(RivalIQ.data.channels.get(me.dashboardModel.getProp('source')).get('postName'));
                        objectTypeNamePlural = `${objectTypeName}s`;
                        break;
                    default:
                        throw new Error(`unknown insight objectType ${objectType}`);
                }

                const text = [
                    'Analyzing',
                    numObjectsFormatted,
                    RivalIQ.formatter.numericLabel(objectTypeName, objectTypeNamePlural, numObjects)
                ];

                me.ui.searchResultsSummary.text(text.join(' '));
            }
        }
    });

}, window.s, window.moment);
